import React, {
  createContext,
  FC,
  ReactNode,
  useContext,
  useState,
} from 'react';

interface HeaderProviderProps {
  children: ReactNode;
}

interface HandleClickType {
  click: boolean;
  type?: string;
}

export interface HeaderContextType {
  stateClick: HandleClickType;
  setStateClick: React.Dispatch<React.SetStateAction<HandleClickType>>;
}

const HeaderContext = createContext<HeaderContextType>({} as HeaderContextType);

export const useHeaderContext = () => useContext(HeaderContext);

export const HeaderProvider: FC<HeaderProviderProps> = ({ children }) => {
  const [stateClick, setStateClick] = useState<HandleClickType>({
    click: false,
  });

  return (
    <HeaderContext.Provider value={{ stateClick, setStateClick }}>
      {children}
    </HeaderContext.Provider>
  );
};
